import { Container } from "react-bootstrap";

const Footer = () => {
    return (
        <footer className="border-top mt-5 py-3 bg-light">
            <Container className="text-center text-muted small">
                Digital Library © 2026
            </Container>
        </footer>
    );
};

export default Footer;